import { useState } from "react";
import classNames from "classnames";
import { SearchModelEnum } from "types/qbank/searchModel";
import { MetaDataPropertyTypes } from "types/metaDataPropertyTypes";
import { PropertyCriteria } from "types/qbank/propertyCriteria";
import {
  Button,
  Icon,
  Level,
  LevelLeft,
  LevelRight,
  Loader,
  Title,
} from "components/ui";
import AdvancedSearchInput from "./AdvancedSearchInput";
import { useFilter } from "hooks/filter";

export default function AdvancedSearchPanel(props: {
  active: boolean;
  closePanel: () => void;
  propertyTypes: MetaDataPropertyTypes;
}) {
  const { searchState, searchDispatch } = useFilter();
  let [advancedSearchFilters, setAdvancedSearchFilters] = useState<
    PropertyCriteria[]
  >([]);
  let [inputValues, setInputValues] = useState<{ [key: string]: any }>({});

  function setCriteria(propertyCriteria: PropertyCriteria) {
    let clone: PropertyCriteria[] = JSON.parse(
      JSON.stringify(advancedSearchFilters)
    );

    clone = clone.filter(
      (existingCriteria) =>
        existingCriteria.systemName !== propertyCriteria.systemName
    );

    // Not passing a value means "remove value" for simplicity's sake
    if (propertyCriteria.value !== undefined) {
      clone.push(propertyCriteria);
    }

    setAdvancedSearchFilters(clone);
  }

  function search() {
    setAdvancedSearchFilters([]);
    setInputValues({});
    searchDispatch({
      type: "ADD_FILTER",
      payload: {
        criteria: SearchModelEnum.properties,
        value: "",
        overwrite: true,
        propertyCriteria: advancedSearchFilters,
        label: true,
      },
    });

    props.closePanel();
  }

  const classes = classNames("advanced-search-panel", {
    "is-active": props.active,
  });

  return (
    <div className={classes}>
      <Level>
        <LevelLeft
          className="advanced-search-panel-back is-clickable"
          onClick={props.closePanel}
        >
          <Icon name="arrow-left" />
          <Title size={5}>Back</Title>
        </LevelLeft>

        <LevelRight>
          <Button
            disabled={Object.keys(inputValues).length === 0}
            onClick={() => setInputValues({})}
          >
            Clear all filters
          </Button>
        </LevelRight>
      </Level>

      {props.propertyTypes ? (
        searchState.currentCategory.propertyRequests.map((systemName) => (
          <div key={systemName}>
            <AdvancedSearchInput
              systemName={systemName}
              propertyTypes={props.propertyTypes}
              setCriteria={setCriteria}
              value={inputValues[systemName]}
              setInputValues={setInputValues}
            />
          </div>
        ))
      ) : (
        <Loader />
      )}

      <Button
        color="primary"
        disabled={Object.keys(inputValues).length === 0}
        onClick={search}
      >
        Search
      </Button>
    </div>
  );
}
